import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { removeNotification } from '../store/slices/notificationSlice';
import styles from './NotificationContainer.module.css';

const NotificationContainer = () => {
    const notifications = useSelector(state => state.notifications.notifications);
    const dispatch = useDispatch();

    useEffect(() => {
        notifications.forEach(notification => {
            if (notification.duration > 0) {
                const timer = setTimeout(() => {
                    dispatch(removeNotification(notification.id));
                }, notification.duration);

                return () => clearTimeout(timer);
            }
        });
    }, [notifications, dispatch]);

    const handleDismiss = (id) => {
        dispatch(removeNotification(id));
    };

    if (notifications.length === 0) return null;

    return (
        <div className={styles.notificationContainer}>
            {notifications.map(notification => (
                <div
                    key={notification.id}
                    className={`${styles.notification} ${styles[notification.type]}`}
                >
                    <div className={styles.notificationContent}>
                        <div className={styles.iconContainer}>
                            {notification.type === 'success' && (
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                                    <polyline points="22,4 12,14.01 9,11.01" />
                                </svg>
                            )}
                            {notification.type === 'error' && (
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <circle cx="12" cy="12" r="10" />
                                    <line x1="15" y1="9" x2="9" y2="15" />
                                    <line x1="9" y1="9" x2="15" y2="15" />
                                </svg>
                            )}
                            {notification.type === 'warning' && (
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                                    <line x1="12" y1="9" x2="12" y2="13" />
                                    <line x1="12" y1="17" x2="12.01" y2="17" />
                                </svg>
                            )}
                            {notification.type === 'info' && (
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <circle cx="12" cy="12" r="10" />
                                    <line x1="12" y1="16" x2="12" y2="12" />
                                    <line x1="12" y1="8" x2="12.01" y2="8" />
                                </svg>
                            )}
                        </div>
                        <span className={styles.message}>{notification.message}</span>
                    </div>
                    <button
                        className={styles.closeButton}
                        onClick={() => handleDismiss(notification.id)}
                        aria-label="Dismiss notification"
                    >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18" />
                            <line x1="6" y1="6" x2="18" y2="18" />
                        </svg>
                    </button>
                </div>
            ))}
        </div>
    );
};

export default NotificationContainer;
